module.exports = __webpack_public_path__ + "static/img/home-5.54906087.png";